"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  "1000": {
    "pt_br": "Erro de servidor, por favor tente mais tarde.",
    "en_en": "Erro de servidor, por favor tente mais tarde."
  },
  "1001": {
    "pt_br": "Ocorreu um erro na validação!",
    "en_en": "Ocorreu um erro na validação!"
  },
  "1002": {
    "pt_br": "Ambiente não definido!",
    "en_en": "Ambiente não definido!"
  },
  "1003": {
    "pt_br": "Ambiente não encontrado!",
    "en_en": "Ambiente não encontrado!"
  },
  "1004": {
    "pt_br": "Usuário não definido!",
    "en_en": "Usuário não definido!"
  },
  "1005": {
    "pt_br": "Usuário não encontrado!",
    "en_en": "Usuário não encontrado!"
  },
  "1006": {
    "pt_br": "Ação não permitida!",
    "en_en": "Ação não permitida!"
  },
  "1007": {
    "pt_br": "Nome de ambiente já existente!",
    "en_en": "Nome de ambiente já existente!"
  },
  "1008": {
    "pt_br": "Erro de sistema: Vari\u00e1vel de ambiente dos servi\u00e7os n\u00e3o definida.",
    "en_en": "Erro de sistema: Vari\u00e1vel de ambiente dos servi\u00e7os n\u00e3o definida."
  },
  "1100": {
    "pt_br": "Usuário e/ou senha incorreto!",
    "en_en": "Usuário e/ou senha incorreto!"
  },
  "1101": {
    "pt_br": "Falha ao excluir a conta. Tente novamente.",
    "en_en": "Falha ao excluir a conta. Tente novamente."
  },
  "1102": {
    "pt_br": "Formato do email est\u00e1 inv\u00e1lido.",
    "en_en": "Formato do email est\u00e1 inv\u00e1lido."
  },
  "1103": {
    "pt_br": "O campo 'Telefone' est\u00e1 inv\u00e1lido.",
    "en_en": "O campo 'Telefone' est\u00e1 inv\u00e1lido."
  },
  "1104": {
    "pt_br": "O DDD informado est\u00e1 inv\u00e1lido.",
    "en_en": "O DDD informado est\u00e1 inv\u00e1lido."
  },
  "1105": {
    "pt_br": "A senha deve conter no m\u00ednimo 8 caracteres.",
    "en_en": "A senha deve conter no m\u00ednimo 8 caracteres."
  },
  "1106": {
    "pt_br": "Este email j\u00e1 foi cadastrado. Tente o login ou utilize outro.",
    "en_en": "Este email j\u00e1 foi cadastrado. Tente o login ou utilize outro."
  },
  "1107": {
    "pt_br": "O campo 'Nome' \u00e9 obrigat\u00f3rio e deve conter no m\u00e1ximo 50 caracteres.",
    "en_en": "O campo 'Nome' \u00e9 obrigat\u00f3rio e deve conter no m\u00e1ximo 50 caracteres."
  },
  "1108": {
    "pt_br": "O campo 'Sobrenome' \u00e9 obrigat\u00f3rio e deve conter no m\u00e1ximo 50 caracteres.",
    "en_en": "O campo 'Sobrenome' \u00e9 obrigat\u00f3rio e deve conter no m\u00e1ximo 50 caracteres."
  },
  "1109": {
    "pt_br": "A data de nascimento informada est\u00e1 inv\u00e1lida.",
    "en_en": "A data de nascimento informada est\u00e1 inv\u00e1lida."
  },
  "1110": {
    "pt_br": "Conta não associada ao ambiente",
    "en_en": "Conta não associada ao ambiente"
  },
  "1111": {
    "pt_br": "Conta já associada!",
    "en_en": "Conta já associada!"
  },
  "1112": {
    "pt_br": "A senha atual n\u00e3o confere.",
    "en_en": "A senha atual n\u00e3o confere."
  },
  "1113": {
    "pt_br": "Facebook ID inv\u00e1lido.",
    "en_en": "Facebook ID inv\u00e1lido."
  },
  "1114": {
    "pt_br": "Email n\u00e3o encontrado.",
    "en_en": "Email n\u00e3o encontrado."
  },
  "1115": {
    "pt_br": "A URL informada \u00e9 inv\u00e1lida.",
    "en_en": "A URL informada \u00e9 inv\u00e1lida."
  },
  "1116": {
    "pt_br": "Falha ao enviar email de recupera\u00e7\u00e3o de senha.",
    "en_en": "Falha ao enviar email de recupera\u00e7\u00e3o de senha."
  },
  "1117": {
    "pt_br": "O token informado n\u00e3o confere.",
    "en_en": "O token informado n\u00e3o confere."
  },
  "1118": {
    "pt_br": "O tempo de recupera\u00e7\u00e3o de senha expirou. Refa\u00e7a o processo novamente.",
    "en_en": "O tempo de recupera\u00e7\u00e3o de senha expirou. Refa\u00e7a o processo novamente."
  },
  "1119": {
    "pt_br": "A data é inv\u00e1lida.",
    "en_en": "A data é inv\u00e1lida."
  },
  "1120": {
    "pt_br": "Genero inv\u00e1lido.",
    "en_en": "Genero inv\u00e1lido."
  },
  "1121": {
    "pt_br": "O CPF é inv\u00e1lido.",
    "en_en": "O CPF é inv\u00e1lido."
  },
  "1122": {
    "pt_br": "Google ID inv\u00e1lido.",
    "en_en": "Google ID inv\u00e1lido."
  },
  "1123": {
    "pt_br": "Este telefone j\u00e1 foi cadastrado. Tente o login ou utilize outro.",
    "en_en": "Este telefone j\u00e1 foi cadastrado. Tente o login ou utilize outro."
  },
  "1200": {
    "pt_br": "O estabelecimento está fechado ou fora do horário de atendimento",
    "en_en": "O estabelecimento está fechado ou fora do horário de atendimento"
  },
  "1300": {
    "pt_br": "Fora da região de entrega",
    "en_en": "Fora da região de entrega"
  },
  "1301": {
    "pt_br": "Sem informações de entrega",
    "en_en": "Sem informações de entrega"
  },
  "1302": {
    "pt_br": "Valor mínimo do pedido não atendido.",
    "en_en": "Valor mínimo do pedido não atendido."
  },
  "1303": {
    "pt_br": "Fora da região de entrega",
    "en_en": "Fora da região de entrega"
  },
  "1304": {
    "pt_br": "Valor do pedido insuficiente para a região de entrega",
    "en_en": "Valor do pedido insuficiente para a região de entrega"
  },
  "1305": {
    "pt_br": "Entrega não definida",
    "en_en": "Entrega não definida"
  },
  "1306": {
    "pt_br": "Endereço de entrega não definido",
    "en_en": "Endereço de entrega não definido"
  },
  "1307": {
    "pt_br": "Geolocalização de entrega não definida",
    "en_en": "Geolocalização de entrega não definida"
  },
  "1308": {
    "pt_br": "Entrega inválida",
    "en_en": "Entrega inválida"
  },
  "1309": {
    "pt_br": "Dados de entrega não definidos",
    "en_en": "Dados de entrega não definidos"
  },
  "1400": {
    "pt_br": "Cupom inválido",
    "en_en": "Cupom inválido"
  },
  "1500": {
    "pt_br": "Pedido inválido",
    "en_en": "Pedido inválido"
  },
  "1600": {
    "pt_br": "O carrinho está vazio",
    "en_en": "O carrinho está vazio"
  },
  "1601": {
    "pt_br": "Carrinho de compras inválido",
    "en_en": "Carrinho de compras inválido"
  },
  "1700": {
    "pt_br": "Forma de pagamento não permitida",
    "en_en": "Forma de pagamento não permitida"
  },
  "1701": {
    "pt_br": "Forma de pagamento não informada",
    "en_en": "Forma de pagamento não informada"
  },
  "5000": {
    "pt_br": "Erro de servidor, por favor tente mais tarde.",
    "en_en": "Erro de servidor, por favor tente mais tarde."
  },
  "5100": {
    "pt_br": "Erro, o campo %field% \u00e9 obrigat\u00f3rio.",
    "en_en": "Erro, o campo %field% \u00e9 obrigat\u00f3rio."
  },
  "5200": {
    "pt_br": "Erro de conex\u00e3o.",
    "en_en": "Erro de conex\u00e3o."
  },
  "5300": {
    "pt_br": "Erro de conex\u00e3o loja.",
    "en_en": "Erro de conex\u00e3o loja."
  },
  "5412": {
    "pt_br": "A data inicial est\u00e1 inv\u00e1lida.",
    "en_en": "A data inicial est\u00e1 inv\u00e1lida."
  },
  "5413": {
    "pt_br": "A data final est\u00e1 inv\u00e1lida.",
    "en_en": "A data final est\u00e1 inv\u00e1lida."
  },
  "5414": {
    "pt_br": "A quantidade de registros informada, excede o limite permitido.",
    "en_en": "A quantidade de registros informada, excede o limite permitido."
  },
  "5415": {
    "pt_br": "O endere\u00e7o \u00e9 obrigat\u00f3rio.",
    "en_en": "O endere\u00e7o \u00e9 obrigat\u00f3rio."
  },
  "5416": {
    "pt_br": "Erro no endere\u00e7o.",
    "en_en": "Erro no endere\u00e7o."
  },
  "5420": {
    "pt_br": "O token de recupera\u00e7\u00e3o de senha n\u00e3o foi informado corretamente.",
    "en_en": "O token de recupera\u00e7\u00e3o de senha n\u00e3o foi informado corretamente."
  },
  "5423": {
    "pt_br": "Falha ao efetuar o cadastro. Tente novamente.",
    "en_en": "Falha ao efetuar o cadastro. Tente novamente."
  },
  "5424": {
    "pt_br": "Falha ao excluir a conta. Tente novamente.",
    "en_en": "Falha ao excluir a conta. Tente novamente."
  },
  "5500": {
    "pt_br": "Erro desconhecido. Tente novamente mais tarde.",
    "en_en": "Erro desconhecido. Tente novamente mais tarde."
  },
  "5501": {
    "pt_br": "Cidade e\/ou bairro n\u00e3o informados.",
    "en_en": "Cidade e\/ou bairro n\u00e3o informados."
  },
  "5502": {
    "pt_br": "Endere\u00e7o e\/ou n\u00famero n\u00e3o informados.",
    "en_en": "Endere\u00e7o e\/ou n\u00famero n\u00e3o informados."
  },
  "5503": {
    "pt_br": "Dados de cidade e bairro n\u00e3o conferem com regi\u00f5es de entrega da loja.",
    "en_en": "Dados de cidade e bairro n\u00e3o conferem com regi\u00f5es de entrega da loja."
  },
  "5504": {
    "pt_br": "Nenhuma informa\u00e7\u00e3o de usu\u00e1rio.",
    "en_en": "Nenhuma informa\u00e7\u00e3o de usu\u00e1rio."
  },
  "5505": {
    "pt_br": "N\u00e3o foi poss\u00edvel encontrar nenhum endere\u00e7o.",
    "en_en": "N\u00e3o foi poss\u00edvel encontrar nenhum endere\u00e7o."
  },
  "5600": {
    "pt_br": "Nenhum registro.",
    "en_en": "Nenhum registro."
  },
  "5601": {
    "pt_br": "Usu\u00e1rio n\u00e3o identificado.",
    "en_en": "Usu\u00e1rio n\u00e3o identificado."
  },
  "5602": {
    "pt_br": "Pedido [%a%] n\u00e3o localizado.",
    "en_en": "Pedido [%a%] n\u00e3o localizado."
  },
  "5603": {
    "pt_br": "O campo [%a%] \u00e9 obrigat\u00f3rio.",
    "en_en": "O campo [%a%] \u00e9 obrigat\u00f3rio."
  },
  "5604": {
    "pt_br": "O campo [%a%] \u00e9 inv\u00e1lido.",
    "en_en": "O campo [%a%] \u00e9 inv\u00e1lido."
  },
  "5605": {
    "pt_br": "ID do pedido obrigat\u00f3rio n\u00e3o foi informado.",
    "en_en": "ID do pedido obrigat\u00f3rio n\u00e3o foi informado."
  },
  "5700": {
    "pt_br": "Estrutura de requisi\u00e7\u00e3o incorreta.",
    "en_en": "Estrutura de requisi\u00e7\u00e3o incorreta."
  },
  "5701": {
    "pt_br": "Estrutura de requisi\u00e7\u00e3o incorreta. Campo(s) [%a%] obrigat\u00f3rio(s)",
    "en_en": "Estrutura de requisi\u00e7\u00e3o incorreta. Campo(s) [%a%] obrigat\u00f3rio(s)"
  },
  "5702": {
    "pt_br": "Etapa [%a%] Estrutura de requisi\u00e7\u00e3o incorreta.",
    "en_en": "Etapa [%a%] Estrutura de requisi\u00e7\u00e3o incorreta."
  },
  "5703": {
    "pt_br": "Produto [%a%] sem quantidade definida.",
    "en_en": "Produto [%a%] sem quantidade definida."
  },
  "5704": {
    "pt_br": "Produto [%a%] n\u00e3o encontrado ou fora do hor\u00e1rio de visualiza\u00e7\u00e3o.",
    "en_en": "Produto [%a%] n\u00e3o encontrado ou fora do hor\u00e1rio de visualiza\u00e7\u00e3o."
  },
  "5705": {
    "pt_br": "Tamanho [%a%] Borda [%b%] n\u00e3o encontrada ou fora do hor\u00e1rio de visualiza\u00e7\u00e3o.",
    "en_en": "Tamanho [%a%] Borda [%b%] n\u00e3o encontrada ou fora do hor\u00e1rio de visualiza\u00e7\u00e3o."
  },
  "5706": {
    "pt_br": "Etapa [%a%] Ingrediente [%b%] n\u00e3o encontrado ou fora do hor\u00e1rio de visualiza\u00e7\u00e3o.",
    "en_en": "Etapa [%a%] Ingrediente [%b%] n\u00e3o encontrado ou fora do hor\u00e1rio de visualiza\u00e7\u00e3o."
  },
  "5707": {
    "pt_br": "Etapa [%a%] Ingrediente [%b%] sem quantidade definida.",
    "en_en": "Etapa [%a%] Ingrediente [%b%] sem quantidade definida."
  },
  "5708": {
    "pt_br": "Produto [%a%] n\u00e3o aceita pagamento por ponto.",
    "en_en": "Produto [%a%] n\u00e3o aceita pagamento por ponto."
  },
  "5709": {
    "pt_br": "Produto [%a%] com etapas, mas nenhuma etapa foi definida.",
    "en_en": "Produto [%a%] com etapas, mas nenhuma etapa foi definida."
  },
  "5710": {
    "pt_br": "Etapa [%a%] n\u00e3o encontrado ou fora do hor\u00e1rio de visualiza\u00e7\u00e3o.",
    "en_en": "Etapa [%a%] n\u00e3o encontrado ou fora do hor\u00e1rio de visualiza\u00e7\u00e3o."
  },
  "5711": {
    "pt_br": "Produto [%a%] com etapas. Etapa com produtos obrigat\u00f3rios, n\u00e3o preenchida.",
    "en_en": "Produto [%a%] com etapas. Etapa com produtos obrigat\u00f3rios, n\u00e3o preenchida."
  },
  "5712": {
    "pt_br": "Produto [%a%] n\u00e3o permite borda.",
    "en_en": "Produto [%a%] n\u00e3o permite borda."
  },
  "5713": {
    "pt_br": "Produto [%a%] n\u00e3o permite divis\u00f5es de borda.",
    "en_en": "Produto [%a%] n\u00e3o permite divis\u00f5es de borda."
  },
  "5714": {
    "pt_br": "Produto [%a%] ultrapassou o limite m\u00e1ximo de divis\u00f5es.",
    "en_en": "Produto [%a%] ultrapassou o limite m\u00e1ximo de divis\u00f5es."
  },
  "5715": {
    "pt_br": "Produto [%a%] c\u00e1lculo de divis\u00f5es, incorreto.",
    "en_en": "Produto [%a%] c\u00e1lculo de divis\u00f5es, incorreto."
  },
  "5716": {
    "pt_br": "Etapa [%a%] Item [%b%] a quantidade de itens \u00e9 maior\/menor que a permitida.",
    "en_en": "Etapa [%a%] Item [%b%] a quantidade de itens \u00e9 maior\/menor que a permitida."
  },
  "5717": {
    "pt_br": "Etapa [%a%] com info extra n\u00e3o preenchida.",
    "en_en": "Etapa [%a%] com info extra n\u00e3o preenchida."
  },
  "5718": {
    "pt_br": "Etapa [%a%] sem Info Extra.",
    "en_en": "Etapa [%a%] sem Info Extra."
  },
  "5719": {
    "pt_br": "Etapa [%a%] Info extra [%b%] com resposta inv\u00e1lida.",
    "en_en": "Etapa [%a%] Info extra [%b%] com resposta inv\u00e1lida."
  },
  "5720": {
    "pt_br": "Tamanho [%a%] n\u00e3o existe.",
    "en_en": "Tamanho [%a%] n\u00e3o existe."
  },
  "5721": {
    "pt_br": "Produto [%a%] Ingredient [%b%] n\u00e3o encontrado ou fora do hor\u00e1rio de visualiza\u00e7\u00e3o.",
    "en_en": "Produto [%a%] Ingredient [%b%] n\u00e3o encontrado ou fora do hor\u00e1rio de visualiza\u00e7\u00e3o."
  },
  "5722": {
    "pt_br": "Produto [%a%] Ingredient [%b%] sem quantidade definida.",
    "en_en": "Produto [%a%] Ingredient [%b%] sem quantidade definida."
  },
  "5800": {
    "pt_br": "Ocorreu um erro.",
    "en_en": "Ocorreu um erro."
  },
  "5801": {
    "pt_br": "Nenhum item foi encontrado para ser processado.",
    "en_en": "Nenhum item foi encontrado para ser processado."
  },
  "5802": {
    "pt_br": "N\u00e3o haviam itens para serem salvos.",
    "en_en": "N\u00e3o haviam itens para serem salvos."
  },
  "5803": {
    "pt_br": "O valor total do pedido n\u00e3o atingiu o valor m\u00ednimo [%a%] para entregar neste endere\u00e7o.",
    "en_en": "O valor total do pedido n\u00e3o atingiu o valor m\u00ednimo [%a%] para entregar neste endere\u00e7o."
  },
  "5804": {
    "pt_br": "Este endere\u00e7o est\u00e1 fora da \u00e1rea de entrega.",
    "en_en": "Este endere\u00e7o est\u00e1 fora da \u00e1rea de entrega."
  },
  "5805": {
    "pt_br": "H\u00e1 erros de valida\u00e7\u00e3o do pedido",
    "en_en": "H\u00e1 erros de valida\u00e7\u00e3o do pedido"
  },
  "5806": {
    "pt_br": "Nenhum pagamento foi identificado",
    "en_en": "Nenhum pagamento foi identificado"
  },
  "5807": {
    "pt_br": "A somat\u00f3ria total de pagamentos [%a%] est\u00e1 diferente do valor total do pedido [%b%]",
    "en_en": "A somat\u00f3ria total de pagamentos [%a%] est\u00e1 diferente do valor total do pedido [%b%]"
  },
  "5808": {
    "pt_br": "Usu\u00e1rio [%a%] n\u00e3o encontrado. Tente o login antes de prosseguir.",
    "en_en": "Usu\u00e1rio [%a%] n\u00e3o encontrado. Tente o login antes de prosseguir."
  },
  "5809": {
    "pt_br": "N\u00e3o foi poss\u00edvel inserir o pedido. Tente novamente.",
    "en_en": "N\u00e3o foi poss\u00edvel inserir o pedido. Tente novamente."
  },
  "5810": {
    "pt_br": "Os items n\u00e3o puderam ser verificados.",
    "en_en": "Os items n\u00e3o puderam ser verificados."
  },
  "5811": {
    "pt_br": "Cupom [%a%] n\u00e3o encontrado ou inv\u00e1lido.",
    "en_en": "Cupom [%a%] n\u00e3o encontrado ou inv\u00e1lido."
  },
  "5812": {
    "pt_br": "Campo [%a%] \u00e9 obrigat\u00f3rio.",
    "en_en": "Campo [%a%] \u00e9 obrigat\u00f3rio."
  },
  "5813": {
    "pt_br": "Item [%a%] [%b%] fora de estoque.",
    "en_en": "Item [%a%] [%b%] fora de estoque."
  },
  "5900": {
    "pt_br": "Produto [%a%] fora de estoque.",
    "en_en": "Produto [%a%] fora de estoque."
  },
  "6000": {
    "pt_br": "O token n\u00e3o foi informado ou est\u00e1 vazio.",
    "en_en": "O token n\u00e3o foi informado ou est\u00e1 vazio."
  },
  "6001": {
    "pt_br": "O email n\u00e3o foi informado ou est\u00e1 com formato inv\u00e1lido.",
    "en_en": "O email n\u00e3o foi informado ou est\u00e1 com formato inv\u00e1lido."
  },
  "6002": {
    "pt_br": "O email n\u00e3o foi informado.",
    "en_en": "O email n\u00e3o foi informado."
  },
  "6003": {
    "pt_br": "Ops! Parece que voc\u00ea j\u00e1 respondeu a pesquisa referente a esse pedido. Agradecemos a sua participa\u00e7\u00e3o!",
    "en_en": "Ops! Parece que voc\u00ea j\u00e1 respondeu a pesquisa referente a esse pedido. Agradecemos a sua participa\u00e7\u00e3o!"
  },
  "6100": {
    "pt_br": "Pedido [%a] n\u00e3o encontrado.",
    "en_en": "Pedido [%a] n\u00e3o encontrado."
  },
  "6101": {
    "pt_br": "Nenhuma trigger encontrada para o pedido [%a]",
    "en_en": "Nenhuma trigger encontrada para o pedido [%a]"
  },
  "7000": {
    "pt_br": "Agendamento não encontrado.",
    "en_en": "Agendamento não encontrado."
  },
  "7001": {
    "pt_br": "O agendamento já foi executado.",
    "en_en": "O agendamento já foi executado."
  },
  "7002": {
    "pt_br": "Já existe um agendamento com esse ID.",
    "en_en": "Já existe um agendamento com esse ID."
  },
  "8000": {
    "pt_br": "Pesquisa não encontrada.",
    "en_en": "Pesquisa não encontrada."
  },
  "8001": {
    "pt_br": "Resposta de pesquisa não encontrada.",
    "en_en": "Resposta de pesquisa não encontrada."
  },
  "9000": {
    "pt_br": "Dados de marketing inválidos",
    "en_en": "Invalid marketing data"
  },
  "10000": {
    "pt_br": "Conta Digital não encontrada.",
    "en_en": "Conta Digital não encontrada."
  }
};
exports.default = _default;
module.exports = exports.default;